import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import WizardButton from '../WizardButton';
import WizardNavigation from '../WizardNavigation';
import Aux from '../../../hoc/Aux';
import WizardStandardHeader from '../WizardStandardHeader';
import * as actions from '../../../store/actions/index';
import { axiosProtected } from '../../../axios-wizard';
import { useTranslation } from 'react-i18next';
import * as modalTypes from '../../Modals/modalTypes';
import WizardButtonList from '../WizardButtonList';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

const wizardStepMediumTypes = (props) => {

  if (props.currentStep !== 'medium_type') {
    return null;
  }

  const { t } = useTranslation();

  const title = (token) => { return  t('wizard.steps.medium_type.values.' + token + '.long') }

  const selectedValues = useSelector(state => state.wizard.selectedSteps.mediumTypes );

  const [buttons, setButtons] = useState([]);

  const dispatch = useDispatch();
  const onSelect = useCallback(
      (stepValue) => dispatch(onSelectAction(stepValue)),
      [dispatch]
    )
  const onDeSelect = useCallback(
      (stepValue) => dispatch(onDeSelectAction(stepValue)),
      [dispatch]
    )
  const onOnlySelect = useCallback(
      (stepValue) => dispatch(onOnlySelectAction(stepValue)),
      [dispatch]
    )

  const showWizardInfoModal = () => {
    const modalProps = {open: true, formObject: { text: 'wizard.steps.medium_type.infotext', title: 'wizard.steps.medium_type.modaltitle' }};
    const modalType = modalTypes.MODAL_SHOW_WIZARD_INFO;
    dispatch(actions.showModal({ modalProps, modalType }));
  }


  const { width } = useWindowDimensions();
  const classRowButtons = () => (width > 1320)? "row" : "row installation-locations";

  useEffect(() => {
      const fetchData = async () => {
        const result = await axiosProtected(
          getButtonsUrl,
        );

        setButtons(result.data);
      };
      fetchData();
    }, []);

  const getButtonsUrl = '/api/step_combinations/medium_type?country=' + props.selectedSteps.country + '&fwk=' + props.selectedSteps.fwk + '&installation_location=' + props.selectedSteps.location + '&execution_type=' + props.selectedSteps.executionType
  const onSelectAction = (stepValue) => { return actions.wizardAddMediumType(stepValue) }
  const onDeSelectAction = (stepValue) => { return actions.wizardRemoveMediumType(stepValue)}
  const onOnlySelectAction = (stepValue) => { return actions.wizardSetMediumType(stepValue)}



  const onSelectShowResults2 = useCallback(
      () => dispatch(actions.wizardGoToResults()),
      [dispatch]
    )

  const wizButton = (x, index) => {
    if (selectedValues.includes(x)) {
      return <WizardButton indexValue={index} key={x} value={x} title={title(x)} onClick={onDeSelect} dividerEnabled={true} btnStyle={'btn-selected'} />
    } else {
      if (props.selectedSteps.executionType === 'k' || props.selectedSteps.executionType === 'v') {
        return <WizardButton indexValue={index} key={x} value={x} title={title(x)} onClick={onSelect} dividerEnabled={true}/>
      } else {
        return <WizardButton indexValue={index} key={x} value={x} title={title(x)} onClick={onOnlySelect} dividerEnabled={true}/>
      }
    }
  }

  const showButton = () => {
    if (selectedValues.length > 0) {
      return (
        <WizardButton key={'direct_results'} title={ t('wizard.steps.medium_types.button.show_results') } onClick={onSelectShowResults2} btnStyle={"wizzard-three yellow-btn"} />
      )
    } else {
      return null;
    }
  }

  const sortCustom = (arrayToSort, customOrder) => {
    let ordering = {};

    for (let i=0; i<customOrder.length; i++) {
      ordering[customOrder[i]] = i;
    }

    return arrayToSort.sort( function(a, b) {
        return (ordering[a] - ordering[b]);
    });

  }

  const sortOrderRohre = ['r', 'rn', 'a', 'ls'];
  const filteredButtonsRohre = buttons.filter(value => sortOrderRohre.includes(value));
  const buttonsRohre = sortCustom(filteredButtonsRohre, sortOrderRohre);

  const sortOrderKabel = ['ke', 'kb', 'kt', 'e', 'ls'];
  const filteredButtonsKabel = buttons.filter(value => sortOrderKabel.includes(value));
  const buttonsKabel = sortCustom(filteredButtonsKabel, sortOrderKabel);

  const sortOrderLueftung = ['lue_r', 'lue_e'];
  const filteredButtonsLueftung = buttons.filter(value => sortOrderLueftung.includes(value));
  const buttonsLueftung = sortCustom(filteredButtonsLueftung, sortOrderLueftung);


  return(
    <Aux>
      <WizardStandardHeader>
        <WizardNavigation />
      </WizardStandardHeader>

      <div className="row justify-content-center content-list-head">
        <div className="col-lg-11 col-xl-11 row ">
          <h2>{t('wizard.steps.medium_type.title')}</h2>
            <button className="btn btn-round" onClick={showWizardInfoModal}>
              <i className="material-icons">help</i>
            </button>
            <p style={{paddingLeft: "10px"}}>{ (props.selectedSteps.executionType === 'k' || props.selectedSteps.executionType === 'v')? t('wizard.steps.medium_type.title_addition') : '' }</p>
        </div>
      </div>

      <div className="row justify-content-center">

        <div className="col-lg-11 col-xl-11">

          {(buttonsRohre.length > 0)?
            <Aux>
              <div className="row">
                <div className="col-12 col-md-10 pt-3"><h3 style={{marginBottom: "0px", fontSize: "1.2rem", color: "#212529c7"}}>{ t('wizard.steps.medium_type.group.rohr') }:</h3></div>
              </div>
              <div className={classRowButtons()}>
              { buttonsRohre.map( (x, index) =>  wizButton(x, index))}
              </div>
            </Aux> : null}

          {(buttonsKabel.length > 0)?
            <Aux>
              <div className="row">
                <div className="col-12 col-md-10 pt-3"><h3 style={{marginBottom: "0px", fontSize: "1.2rem", color: "#212529c7"}}>{ t('wizard.steps.medium_type.group.kabel') }:</h3></div>
              </div>
              <div className={classRowButtons()}>
              { buttonsKabel.map( (x, index) =>  wizButton(x, index))}
              </div>
            </Aux> : null}

          {(buttonsLueftung.length > 0)?
            <Aux>
              <div className="row">
                <div className="col-12 col-md-10 pt-3"><h3 style={{marginBottom: "0px", fontSize: "1.2rem", color: "#212529c7"}}>{ t('wizard.steps.medium_type.group.lueftung') }:</h3></div>
              </div>
              <div className={classRowButtons()}>
              { buttonsLueftung.map( (x, index) =>  wizButton(x, index))}
              </div>
            </Aux> : null}

            <div className="row">
              <div className="col-lg-11 col-xl-11">
                { showButton() }
              </div>
            </div>
        </div>
      </div>



    </Aux>
 );
};

export default wizardStepMediumTypes;



// WEBPACK FOOTER //
// ./src/components/Wizard/Steps/WizardStepMediumTypes.js